import { Button } from "@/components/ui/button";

const CloseButton = ({ 
    btnClasses, 
    width, height,
    handleClick 
}) => {
  return (
    <Button
      variant="outline"
      className={`
        fixed border border-slate-300
        z-10 rounded-full
        drop-shadow-md bg-transparent	
        bg-gradient-to-br p-0
        from-[#ffffff] to-[#efefef]
        ${btnClasses}
      `}
      onClick={() => handleClick(false)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width={width}
        height={height}
        viewBox="0 0 50 50"
      >
        <path
          d="
        M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 
        43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 
        43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"
        />
      </svg>
    </Button>
  );
};

export default CloseButton;
